import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=3dec9943&scoped=true"
import script from "./addService.vue?vue&type=script&lang=js"
export * from "./addService.vue?vue&type=script&lang=js"
import style0 from "./addService.vue?vue&type=style&index=0&id=3dec9943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec9943",
  null
  
)

export default component.exports